import { HeaderSection } from '@/components/Common/HeaderSection/HeaderSection';
import { NavigationTabs } from '@/components/Common/NavigationTabs/NavigationTabs';
import TopLevelSectionLayout from '@/layouts/TopLevelSectionLayout/TopLevelSectionLayout';
import { useSellerProfileViewController } from './SellerProfileViewController';

export function SellerProfile() {
  const { uiState, actions } = useSellerProfileViewController();

  return (
    <TopLevelSectionLayout>
      <HeaderSection
        title={uiState.title}
        showReturn
        status={uiState.status}
        moreActions={uiState.moreActions}
        onMoreActionsClicked={actions.onMoreOptionSelected}
      />
      {uiState.sellerId && (
        <NavigationTabs
          links={[
            {
              to: `/admin/seller/${uiState.sellerId}`,
              label: 'Negocio y Contacto',
            },
            {
              to: `/admin/seller/${uiState.sellerId}/address`,
              label: 'Dirección',
            },
            {
              to: `/admin/seller/${uiState.sellerId}/fiscal`,
              label: 'Datos Fiscales y Facturación',
            },
            {
              to: `/admin/seller/${uiState.sellerId}/sales-delivery`,
              label: 'Compras y Entregas',
            },
          ]}
        />
      )}
    </TopLevelSectionLayout>
  );
}
